import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_ACTEXTRA_ESTUDIANTES = 'ALL_ACTEXTRA_ESTUDIANTES';
export const LOADING_ALL_ACTEXTRA_ESTUDIANTES =
  'LOADING_ALL_ACTEXTRA_ESTUDIANTES';
export const ACTIVO_ACTEXTRA_ESTUDIANTES = 'ACTIVO_ACTEXTRA_ESTUDIANTES';
export const PARAMS_ACTEXTRA_ESTUDIANTES = 'PARAMS_ACTEXTRA_ESTUDIANTES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const actExtraEstudiantesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ACTEXTRA_ESTUDIANTES:
      return {
        ...state,
        all: action.payload.data,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ACTEXTRA_ESTUDIANTES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ACTEXTRA_ESTUDIANTES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ACTEXTRA_ESTUDIANTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
